/** All available types for standard report filters */
export enum ReportFilterTypeEnum {
  /** Numeric value */
  NUMBER = 'NUMBER',
  /** String value (usually, text search pattern) */
  STRING = 'STRING',
  /** Enumeration value (filter descriptor will provide enumeration values and their display names) */
  ENUM = 'ENUM',
  /** Analytics criteria. Same as {@link ReportFilterTypeEnum.ENUM} but can be used only in report analytics API. */
  ANALYTICS_CRITERIA = 'ANALYTICS_CRITERIA',
  /** Subtotal criteria. Same as {@link ReportFilterTypeEnum.ENUM} but can be used only in report subtotal API. */
  SUBTOTAL_CRITERIA = 'SUBTOTAL_CRITERIA',
  /** The time period over which each chart value is calculated. Same as {@link ReportFilterTypeEnum.ENUM} but can be used only in report plot API. */
  PLOT_PERIOD_UNIT = 'PLOT_PERIOD_UNIT',
  /** The value by which the graph is plotted. Same as {@link ReportFilterTypeEnum.ENUM} but can be used only in report plot API. */
  PLOT_VALUE = 'PLOT_VALUE',
  /** The formula by which the values on the graph are calculated. Same as {@link ReportFilterTypeEnum.ENUM} but can be used only in report plot API. */
  PLOT_FORMULA = 'PLOT_FORMULA',
  /** Item column to select. Same as {@link ReportFilterTypeEnum.ENUM} but can be used only in report items API. */
  ITEM_COLUMN = 'ITEM_COLUMN',
  /** Single date value */
  DATE = 'DATE',
  /** Boolean value */
  BOOLEAN = 'BOOLEAN',
  /** Numeric FRM entity's unique key (ID or code) */
  NUMERIC_FRM_ENTITY_KEY = 'NUMERIC_FRM_ENTITY_KEY',
  /** String entity's primary key (ID or code) */
  STRING_FRM_ENTITY_KEY = 'STRING_FRM_ENTITY_KEY',
  /**
   * Dates period start value. Same as {@link ReportFilterTypeEnum.DATE} but can
   * be united into one input element with {@link ReportFilterTypeEnum.TO_DATE}-type filter
   */
  FROM_DATE = 'FROM_DATE',
  /**
   * Dates period end value. Same as {@link ReportFilterTypeEnum.DATE} but can
   * be united into one input element with {@link ReportFilterTypeEnum.FROM_DATE}-type filter
   */
  TO_DATE = 'TO_DATE',
  /**
   * Internal user ids start value. Can be united into one input element with
   * {@link ReportFilterTypeEnum.TO_EXTERNAL_USER_IDS}-type filter
   */
  FROM_USER_IDS = 'FROM_USER_IDS',
  /**
   * External user ids end value. Can be united into one input element with
   * {@link ReportFilterTypeEnum.FROM_USER_IDS}-type filter
   */
  TO_EXTERNAL_USER_IDS = 'TO_EXTERNAL_USER_IDS',
  /** Filted must be standard dropdown created by descriptor */
  DROPDOWN_BY_DESCRIPTOR = 'DROPDOWN_BY_DESCRIPTOR',
}
